

export enum DisplayType {
    grid = 'grid',
    doublegrid = 'doublegrid',
    map = 'map',
}


export enum DisplayType {
    grid = 'grid',
    doublegrid = 'doublegrid',
    map = 'map',
}
